import { useTranslations } from 'next-intl';
import ImageItemListSection, {
  ImageItemListItem,
} from './ImageItemListSection';

const getItems = (t: (key: string) => string): ImageItemListItem[] => [
  {
    id: 'inflammation',
    title: t('photon.muscleRecoverySection.item.inflammation'),
    description: t('photon.muscleRecoverySection.item.inflammationDesc'),
  },
  {
    id: 'joint-support',
    title: t('photon.muscleRecoverySection.item.jointSupport'),
    description: t('photon.muscleRecoverySection.item.jointSupportDesc'),
  },
  {
    id: 'post-workout',
    title: t('photon.muscleRecoverySection.item.postWorkout'),
    description: t('photon.muscleRecoverySection.item.postWorkoutDesc'),
  },
  {
    id: 'deep-tissue',
    title: t('photon.muscleRecoverySection.item.deepTissue'),
    description: t('photon.muscleRecoverySection.item.deepTissueDesc'),
  },
];

const MuscleRecoverySection = () => {
  const t = useTranslations('photon');

  return (
    <ImageItemListSection
      eyebrow={t('photon.muscleRecoverySection.eyebrow.musclesJoints')}
      heading={t('photon.muscleRecoverySection.heading.deeperRecovery')}
      description={t('photon.muscleRecoverySection.description.reachesMuscle')}
      items={getItems(t)}
      image="web_v2/photon/landing-page/muscle-health-v3.png"
      imageAlt={t('photon.muscleRecoverySection.image.muscleRecoveryAlt')}
      mediaSide="right"
    />
  );
};

export default MuscleRecoverySection;
